import { render, staticRenderFns } from "./SwitchButtonComponent.vue?vue&type=template&id=cf1a7f80"
import script from "./SwitchButtonComponent.vue?vue&type=script&lang=js"
export * from "./SwitchButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./SwitchButtonComponent.vue?vue&type=style&index=0&id=cf1a7f80&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports